import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  className: null,
  targetClassName: null,
};

const propTypes = {
  anchor: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  className: PropTypes.string,
  targetClassName: PropTypes.string,
};

export default function ScrollSpyItem({
  anchor,
  label,
  className,
  targetClassName,
  ...rest
}) {
  return (
    <div>
      <a
        href={`#${anchor}`}
        className={clsx(
          'whitespace-nowrap text-base lg:text-lg',
          targetClassName,
          className
        )}
        {...rest}
      >
        {label}
      </a>
    </div>
  );
}

ScrollSpyItem.defaultProps = defaultProps;
ScrollSpyItem.propTypes = propTypes;
